import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LocationSection from './components/LocationSection';
import ServicesSection from '../../home/components/ServicesSection';
import BenefitsSection from '../../home/components/BenefitsSection';
import TintShadesSection from '../../home/components/TintShadesSection';
import TestimonialsSection from '../../home/components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from '../../home/components/CTASection';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema } from '../../../utils/seo';
import { useEffect } from 'react';

export default function ColumbiaPage() {
  // Apply localized SEO metadata with geo-tags
  useSEO({
    title: 'Columbia Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
    description:
      'Professional window tinting services in Columbia, Maryland. Expert ceramic tint installation, mobile service, commercial tinting, vehicle decals, and headlight tinting. Serving Columbia, Ellicott City, Laurel. Lifetime warranty. Call (443) 800-0348.',
    keywords:
      'window tinting Columbia, ceramic tint Columbia MD, mobile tinting Columbia, commercial tinting Columbia, vehicle decals Columbia',
    canonical: '/locations/columbia',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          ...generateLocalBusinessSchema(),
          '@type': 'AutoRepair',
          name: 'U.B.K Window Tint - Columbia',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: 'Columbia',
            addressRegion: 'MD',
            postalCode: '21044',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: '39.2037',
            longitude: '-76.8610',
          },
          areaServed: {
            '@type': 'City',
            name: 'Columbia',
            '@id': 'https://en.wikipedia.org/wiki/Columbia,_Maryland',
          },
        },
        generateWebPageSchema(
          'Columbia Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint',
          'Professional window tinting services in Columbia, Maryland with lifetime warranty and same-day service.',
          '/locations/columbia'
        ),
      ],
    },
  });

  useEffect(() => {
    // Add geo meta tags for local SEO
    const geoTags = [
      { name: 'geo.region', content: 'US-MD' },
      { name: 'geo.placename', content: 'Columbia' },
      { name: 'geo.position', content: '39.2037;-76.8610' },
      { name: 'ICBM', content: '39.2037, -76.8610' },
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <header>
        <h1 className="sr-only">
          Columbia Window Tinting Services - Premium Ceramic Tint - U.B.K Window Tint
        </h1>
      </header>
      <main>
        <HeroSection />
        <LocationSection />
        <ServicesSection />
        <BenefitsSection />
        <TintShadesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
